import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "copywriting-aide" }
const _hoisted_2 = { class: "main-left" }
const _hoisted_3 = { class: "intelligent-agent" }
const _hoisted_4 = { class: "option" }
const _hoisted_5 = { class: "option-left" }
const _hoisted_6 = { class: "option-hot" }
const _hoisted_7 = {
  class: "hot-content my-scroller",
  "infinite-scroll-delay": 1000,
  "infinite-scroll-distance": 10,
  "infinite-scroll-immediate": false
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "hot-content-item-header" }
const _hoisted_10 = { class: "title ellipsis" }
const _hoisted_11 = {
  key: 0,
  class: "hotTime ellipsis"
}
const _hoisted_12 = { class: "hot-content-item-footer" }
const _hoisted_13 = { class: "content ellipsis" }
const _hoisted_14 = { class: "tooltip-content" }
const _hoisted_15 = {
  key: 0,
  style: {"margin-right":"10px","color":"red"}
}
const _hoisted_16 = { class: "tooltip-content-overflow" }
const _hoisted_17 = { class: "option-template" }
const _hoisted_18 = { class: "template-header" }
const _hoisted_19 = { class: "template-labels" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "header-filter" }
const _hoisted_22 = { class: "filter-icon" }
const _hoisted_23 = {
  class: "template-content my-scroller",
  "infinite-scroll-delay": 1000,
  "infinite-scroll-distance": 10,
  "infinite-scroll-immediate": false
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "template-category" }
const _hoisted_26 = { class: "tooltip-content" }
const _hoisted_27 = {
  key: 0,
  style: {"margin-right":"10px","color":"red"}
}
const _hoisted_28 = { class: "template-title ellipsis" }
const _hoisted_29 = { class: "tooltip-content-overflow" }
const _hoisted_30 = { class: "option-right" }
const _hoisted_31 = { class: "content-rendering" }
const _hoisted_32 = { class: "generate-button" }
const _hoisted_33 = { class: "main" }
const _hoisted_34 = { class: "main-header" }
const _hoisted_35 = { class: "left" }
const _hoisted_36 = {
  key: 0,
  class: "right"
}
const _hoisted_37 = { class: "main-body" }
const _hoisted_38 = {
  key: 0,
  class: "edit-mode",
  "element-loading-background": "rgba(0,0,0,0)"
}
const _hoisted_39 = {
  key: 1,
  style: {"width":"100%","display":"flex","align-items":"center","justify-content":"center"}
}

import { ref, onMounted, nextTick, watch, reactive, getCurrentInstance, computed } from 'vue'
import useHotData from '@/hooks/useHotData.ts'
import useTemplateData from '@/hooks/useTemplateData.ts'
import { getToken, getTeamId } from '@/api';
import { useMainStore } from '@/pinia';
import { queryProject } from '@/request/index';
import { ElMessageBox, ElMessage } from 'element-plus';
import { copyText } from '@/utils/index.ts'
import lzwcQuillEditor from './LzwcQuillEditor.vue'
import copyHistoryResult from './CopyHistoryResult.vue'
import copywritingData from './CopywritingData.vue'
import myTemplateFilter from '@/views/templateList/components/templateFilter.vue'
import Background from '@/views/newVideo/components/left/background.vue';
import { useRouter } from 'vue-router';
import { debounce } from '@/utils/index.ts'

import useCreateContent from '@/hooks/useCreateContent'

export default /*@__PURE__*/_defineComponent({
  __name: 'CopywritingAide',
  setup(__props, { expose: __expose }) {

const router = useRouter();
let gotoCreateTemplateFn = () => {
  router.push({ path: '/template-list', })
}

const store = useMainStore();

// 对话id
// let sessionId = ref('')
let activeTab = ref('全部')
let lzwcQuillEditorRef = ref(null)

// 富文本的内容
let content = computed(() => lzwcQuillEditorRef.value.getDataFn().content)

// 智能体
let projectOptions = ref([]);
let projectId = ref('');


let mainPattern = ref('编辑模式')




let copywritingDataRef = ref(null)
let hotTemplateObj = ref({
  hot: null, template: null
})
let formatContent = computed(() => {
  const hotContent = hotTemplateObj.value.hot?.content || '';
  const templateContent = hotTemplateObj.value.template?.content || '';

  if (templateContent && hotContent) {
    return templateContent.replace(/\{([^}]+)\}/, hotContent);
  }

  return templateContent || hotContent;
});
// ai文章创作
const creating = ref(false);
const createLoading = ref(false);


// 热点
const { hotData, hotLoadFn, loadHotLoadFn, clickItemHotFn } = useHotData();
// 模板
const { templateData, templateLoadFn, wordDataTypeDic, selectedTypeArr, loadTemplateLoadFn, tradeTypeDic, changeTemplateTypeFn, fetchTradeTypeDic, fetchWordDataTypeDic } = useTemplateData();
// aichat
const { streamRequest, sessionId, addChatHistoryRecordFn, getTeamAiHistoryLists, teamAiHistoryLists } = useCreateContent()
// 行业类型
let industryArr = ref([])
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
  changeTemplateTypeFn(tab === '全部' ? [] : [tab])
};



// 过滤模板
let sumbitFilterFn = async (form) => {
  await nextTick(() => {
    templateData.value.keyword = form.keyword || ''
    templateData.value.trade = form.trade || ''
  })
  changeTemplateTypeFn('')
}




// 点击的新闻热点
let clickHotItemFn = (item) => {
  if (!hotTemplateObj.value.hot || item.id !== hotTemplateObj.value.hot.id) hotTemplateObj.value.hot = item
  else hotTemplateObj.value.hot = null

}
// 点击的模板
let clickTemplateItemFn = (item) => {
  if (!hotTemplateObj.value.template || item.id !== hotTemplateObj.value.template.id) hotTemplateObj.value.template = item
  else hotTemplateObj.value.template = null

}



// 按钮ai创作文章
let aiCreateArticleFn = debounce(async (refs) => {
  try {
    await refs.setContentFn('')
    let { form: { customContent } } = await copywritingDataRef.value.submitForm()
    // 把ai创作的内容
    createLoading.value = true

    streamRequest({
      url: '/api/app/ai/steam-chat/chat',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken(),
        'App-Team-Id': getTeamId(),
      },
      data: { word: customContent, templateId: hotTemplateObj.value.template?.id || '', hotId: hotTemplateObj.value.hot?.id || '', id: store.projectId },
      processFn: (answer) => {
        refs.setContentStreamingFn(answer)
      }
    }).then(async (chatContent) => {

      await nextTick(() => refs.setSessionIdFn(sessionId.value))
      addChatHistoryRecordFn({ "inputContent": customContent, chatContent })
    }).catch((error) => {
      console.error('Error:', error);
    }).finally(() => createLoading.value = false)
  } catch (error) {
    console.log('error', error);
  }

}, 200)



let changePrjFn = (id) => {
  store.setProjectId(id);
};
const getProject = async () => {
  try {
    const response = await queryProject();
    if (response.data.code == 200) {
      // 填充下拉菜单的选项
      projectOptions.value = response.data.data.map((project) => ({
        label: project.projectName,
        value: project.id,
      }));
      // 默认选中第一条数据的id
      if (projectOptions.value.length > 0) {
        projectId.value = store.projectId ? store.projectId : projectOptions.value[0].value;
        store.setProjectId(projectId.value);
      }
    }
  } catch (error) {
    console.error('Failed to query project:', error);

  }
};

// 获取智能体
getProject();
// 获取行业
watch(() => wordDataTypeDic.value, (arr) => {
  industryArr.value = [{
    "value": "",
    "label": "全部",
    "dictCode": "word_template_type"
  }, ...arr]

  // industryArr.value = [{
  //   "value": "",
  //   "label": "全部",
  //   "dictCode": "word_template_type"
  // }, ...arr, {
  //   "value": "01",
  //   "label": "制造业",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "02",
  //   "label": "金融业",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "03",
  //   "label": "信息技术",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "04",
  //   "label": "教育",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "05",
  //   "label": "医疗健康",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "06",
  //   "label": "房地产",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "07",
  //   "label": "服务业",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "08",
  //   "label": "能源与矿业",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "09",
  //   "label": "交通运输",
  //   "dictCode": "word_template_type"
  // }, {
  //   "value": "10",
  //   "label": "政府与公共管理",
  //   "dictCode": "word_template_type"
  // }]
})




onMounted(() => {

  hotLoadFn();
  templateLoadFn();
  fetchWordDataTypeDic(); // 如果需要获取字典数据的话
  fetchTradeTypeDic(); // 如果需要获取字典数据的话
});

// 暴露所需参数和方法
let getDataFn = () => {
  return { content: content.value, hotTemplateObj: hotTemplateObj.value }
}
let setContentFn = (customContent) => {
  lzwcQuillEditorRef.value.setContentFn(customContent)
}

__expose({ getDataFn, setContentFn })

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form_item, { label: "智能体：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(projectId),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(projectId) ? (projectId).value = $event : projectId = $event)),
              placeholder: "请选择所属智能体",
              style: {"color":"#000"},
              onChange: _unref(changePrjFn)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectOptions), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hot-header" }, "新闻热点", -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hotData).data, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["hot-content-item", [_unref(hotTemplateObj).hot && _unref(hotTemplateObj).hot.id === i.id ? 'hot-selected' : null]]),
                  key: i,
                  onClick: ($event: any) => (_unref(clickHotItemFn)(i))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(i.title), 1),
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(i.hotTime), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        placement: "top",
                        offset: 30,
                        "hide-after": 100,
                        disabled: i.content && i.content.length <= 25
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(i.content), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            (i.hot)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                  _createVNode(_component_svgIcon, { iconClass: 'hotSpotFlame' }),
                                  _createTextVNode(_toDisplayString(i.hot), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(i.content), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["disabled"])
                    ])
                  ])
                ], 10, _hoisted_8))
              }), 128))
            ])), [
              [_directive_infinite_scroll, _unref(loadHotLoadFn)]
            ])
          ]),
          _createVNode(_component_el_divider, { class: "divider" }),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "模板:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedTypeArr), (i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: i.value,
                    class: _normalizeClass([{ 'template-label-active': _unref(templateData).belong === i.value }, "template-label"]),
                    onClick: ($event: any) => ((_unref(templateData).belong = i.value) && _unref(changeTemplateTypeFn)(''))
                  }, _toDisplayString(i.label), 11, _hoisted_20))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_popover, {
                  placement: "right",
                  title: "搜索",
                  width: "200",
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Filter)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(myTemplateFilter, {
                      industryTabs: _unref(tradeTypeDic),
                      onSumbitFn: _unref(sumbitFilterFn)
                    }, null, 8, ["industryTabs", "onSumbitFn"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_popconfirm, {
                  placement: "right",
                  title: "前去新建模板,创建属于自己的专用模板",
                  onConfirm: _unref(gotoCreateTemplateFn)
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      circle: ""
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("GO")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onConfirm"])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateData).data, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["template-content-item", [_unref(hotTemplateObj).template && _unref(hotTemplateObj).template.id === i.id ? 'template-selected' : null]]),
                  key: i,
                  onClick: ($event: any) => (_unref(clickTemplateItemFn)(i))
                }, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(i.title), 1),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    placement: "top",
                    offset: 30,
                    "hide-after": 100,
                    disabled: i.content && i.content.length <= 25
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(i.description || i.content), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        (i.hot)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _createVNode(_component_svgIcon, { iconClass: 'hotSpotFlame' }),
                              _createTextVNode(_toDisplayString(i.hot), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(i.description || i.content), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["disabled"])
                ], 10, _hoisted_24))
              }), 128))
            ])), [
              [_directive_infinite_scroll, _unref(loadTemplateLoadFn)]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(copywritingData, {
              ref_key: "copywritingDataRef",
              ref: copywritingDataRef,
              content: _unref(formatContent)
            }, null, 8, ["content"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_el_button, {
              class: "el-button el-button--primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(aiCreateArticleFn)(_unref(lzwcQuillEditorRef))))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("一键创作文章")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", {
            style: _normalizeStyle({ color: _unref(mainPattern) === '编辑模式' ? '#4744c9' : null, cursor: 'pointer' }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(mainPattern) //@ts-ignore
 ? mainPattern.value = '编辑模式' : mainPattern = '编辑模式'))
          }, " 编辑模式", 4),
          _createElementVNode("div", {
            style: _normalizeStyle({ color: _unref(mainPattern) === '历史结果' ? '#4744c9' : null, cursor: 'pointer' }),
            onClick: _cache[3] || (_cache[3] = ($event: any) => ((_isRef(mainPattern) //@ts-ignore
 ? mainPattern.value = '历史结果' : mainPattern = '历史结果') && _unref(getTeamAiHistoryLists)()))
          }, " 历史结果", 4)
        ]),
        (_unref(mainPattern) === '编辑模式')
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", {
                style: {"cursor":"pointer","color":"#2c3e50c2"},
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(content).length && _unref(copyText)(_unref(content))))
              }, "复制全文 ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_37, [
        (_unref(mainPattern) === '编辑模式')
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createVNode(lzwcQuillEditor, {
                ref_key: "lzwcQuillEditorRef",
                ref: lzwcQuillEditorRef
              }, null, 512),
              false
                ? (_openBlock(), _createBlock(_component_quill_editor, {
                    key: 0,
                    ref: "quillEditorRef",
                    placeholder: "文案创作不用愁，AI文案助理智慧加持，让每一篇作品都成为吸睛焦点！",
                    content: _unref(content),
                    "onUpdate:content": _cache[5] || (_cache[5] = ($event: any) => (_isRef(content) ? (content).value = $event : content = $event)),
                    theme: "snow",
                    contentType: "text",
                    toolbar: [],
                    class: "edit-mode-ql-editor"
                  }, null, 8, ["content"]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, createLoading.value]
            ])
          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
              (_unref(teamAiHistoryLists).length)
                ? (_openBlock(), _createBlock(copyHistoryResult, {
                    key: 0,
                    teamAiHistoryLists: _unref(teamAiHistoryLists)
                  }, null, 8, ["teamAiHistoryLists"]))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "暂无历史"
                  }))
            ]))
      ])
    ])
  ]))
}
}

})